import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { FuseConfigService } from "@fuse/services/config.service";
import { environment } from '../../../../environments/environment'

@Component({
    selector: "app-charger-summary",
    templateUrl: "./charger-summary.component.html",
    styleUrls: ["./charger-summary.component.scss"],
})
export class ChargerSummaryComponent implements OnInit {
    consumptionData: any;
    chargerData: any[] = [];

    chargerId = "";
    stationId = "";
    connectorId = "";

    userId = "";
    mobileNo = "";

    stationName = "";

    consuptionBalance: any = "";

    constructor(
        private configService: FuseConfigService,
        private snackBar: MatSnackBar,
        private router: Router
    ) {
        this.configService.config = {
            layout: {
                navbar: { hidden: true },
                toolbar: { hidden: true },
                footer: { hidden: true },
                sidepanel: { hidden: true },
            },
        };
    }

    ngOnInit(): void {
        this.consuptionBalance = sessionStorage.getItem("consuptionBalance") ?? 0;
        this.loadUserData();
        this.loadChargerData();
        this.loadConsumptionData();
        this.fetchConnectorStatus();
    }

    private loadUserData(): void {
        this.userId = sessionStorage.getItem("web_user_id") ?? "";
        this.mobileNo = sessionStorage.getItem("web_mobile") ?? "";

        if (!this.userId && !this.mobileNo) {
            this.router.navigate(["/web-login"]);
        }
    }

    private loadChargerData(): void {
        const rawText = sessionStorage.getItem("charger_data");

        if (!rawText) {
            this.router.navigate(["/scan-charger"]);
            return;
        }

        const [chargerId, stationId, connectorId] = rawText.trim().split(/\s+/);
        this.chargerId = chargerId;
        this.stationId = stationId;
        this.connectorId = connectorId;
    }

    private loadConsumptionData(): void {
        const sessionData = sessionStorage.getItem("consumptionData");

        if (!sessionData) {
            this.router.navigate(["/charger-home"]);
            return;
        }

        this.consumptionData = JSON.parse(sessionData);
    }

    private showMessage(message: string): void {
        this.snackBar.open(message, "Dismiss", { duration: 5000 });
    }

    async fetchConnectorStatus(): Promise<void> {
        // const url = `https://cmsapi.vmatic.co.in/chrgStation/gtConnectorStatusBySCC/${this.stationId}/${this.chargerId}/${this.connectorId}`;
        const url = `${environment.API_URL2}/chrgStation/gtConnectorStatusBySCC/${this.stationId}/${this.chargerId}/${this.connectorId}`;

        try {
            const res = await fetch(url);
            const json = await res.json();

            if (json?.data?.[0]) {
                this.chargerData = json.data[0];
                this.stationName = json.data[0].station_name;
            }
        } catch (err) {
            console.error("Fetch connector status error:", err);
            this.showMessage("Failed to fetch connector status.");
        }
    }
}
